'use es6';

import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ReportsTableContainer from './ReportsTableContainer';
import TemplatesPageContainer from './TemplatesPageContainer';
import { ReportsViewContainer } from './ReportsViewContainer';
import CustomListingPageWrapper from './CustomListingPageWrapper';
import SingleReportViewerContainer from './SingleReportViewerContainer';
import ReportCollectionHomesContainer from './ReportCollectionHomesContainer';
import { getIsUngatedToReportListViewToggle } from '../selectors/gatesSelector';
import { jsx as _jsx } from "react/jsx-runtime";
const ReportsListingPage = ({
  isLoading: isBusinessUnitsLoading
}) => {
  const isUngatedToReportListViewToggle = useSelector(getIsUngatedToReportListViewToggle);
  const {
    templateId,
    reportId,
    collectionId
  } = useParams();
  const isTemplatesPage = templateId;
  const isCollectionHomePage = !templateId && collectionId;
  const isSingleReportViewer = reportId;
  const childContainer = useMemo(() => {
    if (isCollectionHomePage) {
      return /*#__PURE__*/_jsx(ReportCollectionHomesContainer, {});
    }
    if (isTemplatesPage) {
      return /*#__PURE__*/_jsx(TemplatesPageContainer, {});
    }
    if (isSingleReportViewer) {
      return /*#__PURE__*/_jsx(SingleReportViewerContainer, {
        reportId: reportId
      });
    }
    if (isUngatedToReportListViewToggle) {
      return /*#__PURE__*/_jsx(ReportsViewContainer, {});
    }
    return /*#__PURE__*/_jsx(ReportsTableContainer, {
      isBusinessUnitsLoading: isBusinessUnitsLoading
    });
  }, [isCollectionHomePage, isTemplatesPage, isSingleReportViewer, isBusinessUnitsLoading, reportId, isUngatedToReportListViewToggle]);
  return /*#__PURE__*/_jsx(CustomListingPageWrapper, {
    children: childContainer
  });
};
ReportsListingPage.propTypes = {
  isLoading: PropTypes.bool
};
export default ReportsListingPage;